<template>
  <div>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Filter by</span>
      <div class="wf-w-1/2">
        <select class="wf-w-full wf-text-sm" v-model="filterBy">
          <option value="ALL">All</option>
          <option value="OFFER">Offer</option>
          <option value="PRODUCT">Product</option>
          <option value="COLLECTION">Collection</option>
          <option value="CUSTOM">Custom</option>
        </select>
      </div>
    </li>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2" v-if="filterBy != 'CUSTOM' && filterBy != 'ALL'">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide" v-text="filterByText"></span>
      <div class="wf-w-1/2">
        <input
          v-model="filterIds"
          type="text"
          class="wf-w-full wf-text-right focus:wf-bg-gray-300 wf-text-xs wf-bg-gray-300 wf-text-gray-700 wf-border wf-rounded focus:wf-outline-none wf-px-2 wf-py-1"
        />
      </div>
    </li>
    <li v-if="filterBy == 'CUSTOM' " class="wf-flex wf-justify-end">
      <a href="#" @click.prevent="addCustomOrders" class="wf-text-xs wf-semibold wf-tracking-wide wf-text-blue-500 wf-underline">add custom orders</a>
    </li>
    <SocialProofCustomOrdersModal @change="updateOrders"/>
  </div>
</template>

<script>
  import _ from 'lodash'
  import SocialProofCustomOrdersModal from './SocialProofCustomOrdersModal'
  import MenuContentProperty from '../contracts/MenuContentProperty'
  export default MenuContentProperty.extend({
    components: { SocialProofCustomOrdersModal },
    computed: {
      filterByText() {
        return this.filterBy == 'OFFER' ? 'Offers Ids' : 'Products Ids'
      },
      filterBy: {
        get() {
          return this.elementContent.filterBy
        },
        set(value) {
          this.addToObject(this.module, {filterBy: value}, 'content', null, {}, true, this.parentModule)
        }
      },
      filterIds: {
        get() {
          return this.elementContent.filterIds
        },
        set: _.debounce(function (value) {
          this.addToObject(this.module, {filterIds: value}, 'content', null, {}, true, this.parentModule)
        }, 1000)
      }
    },
    methods: {
      addCustomOrders() {
        this.$modal.show('social-proof-custom-orders', {
          customOrders: this.elementContent.customOrders,
        })
      },
      updateOrders(value) {
        this.addToObject(this.module, {customOrders: value}, 'content', null, {}, true, this.parentModule)
      }
    },
  })
</script>